// components/ServiceCategoryCard.jsx
import React, { useRef } from "react";
import "./ServiceCategoryCard.css";

const ServiceCategoryCard = ({ category, onGetQuote }) => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollLeft +=
        direction === "left" ? -scrollAmount : scrollAmount;
    }
  };

  return (
    <div className="category-card">
      {/* Category Header */}
      <div className="category-header">
        <div className="category-icon-wrapper">
          <img
            src={category.icon}
            alt={category.title}
            className="category-icon"
          />
        </div>
        <h2 className="category-title">{category.title}</h2>
        <p className="category-description">{category.description}</p>
      </div>

      {/* Subcategories Carousel */}
      <div className="subcategories-container">
        <button
          className="carousel-arrow left"
          onClick={() => scroll("left")}
          aria-label="Previous services"
        >
          ‹
        </button>

        <div className="subcategories-carousel" ref={scrollRef}>
          {category.subcategories.map((subcategory, index) => (
            <div key={index} className="subcategory-item">
              <div className="subcategory-content">
                <h3 className="subcategory-title">{subcategory.title}</h3>
                <p className="subcategory-description">
                  {subcategory.description}
                </p>

                <div className="subcategory-features">
                  {subcategory.features.map((feature, idx) => (
                    <span key={idx} className="feature-tag">
                      {feature}
                    </span>
                  ))}
                </div>

                <button
                  className="quote-btn"
                  onClick={() => onGetQuote(category.title, subcategory.title)}
                >
                  Get Quote for {subcategory.title}
                </button>
              </div>
            </div>
          ))}
        </div>

        <button
          className="carousel-arrow right"
          onClick={() => scroll("right")}
          aria-label="Next services"
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default ServiceCategoryCard;
